import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Constants } from '../../../shared/constants';
import { callType, empType, empTypes, userCalltypes } from '../../../shared/models/user.model';
import { LocalDataService } from '../../../shared/services/local-data.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../login.service';
import { LocalizationService } from '../../../shared/localization/localization.service';
import {AppConfigService} from 'src/app/shared/services/app-config/app-config.service';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent {

  userData: any;
  languageSkills: any = [];
  userLanguageSkills: any;
  userCalltypes: callType[] = userCalltypes;
  employeeType: empType[] = empTypes;
  userProfileForm: any;

  constructor(
    public _dialogRef: MatDialogRef<UserProfileComponent>,
    private _formBuilder: FormBuilder,
    private _notificationService: NotificationService,
    private _localDataService: LocalDataService,
    private _localizationService: LocalizationService,
    private _loginService: LoginService,
  ) {
    // Localization
    _localDataService.selectedScreen = ['user_profile'];
    _localizationService.use(this._localDataService.selectedCountry + '_' + this._localDataService.selectedLanguage, [...Constants.Localization.commonAreas, ..._localDataService.selectedScreen]);
    // User details
    this.userData = this._localDataService.getLoginData('user');
    this.languageSkills = this._localDataService.getLanguageSkills();
    this.userLanguageSkills = (this.userData?.['languageSkillsId'])?.split(",");
    let roleName = this._localizationService.instant('user_profile.role'+this.userData.roleId);
    this.userProfileForm = this._formBuilder.group({
      emailId: [this.userData.emailId],
      country: [this.userData.countryName],
      userRole: [roleName],
      agentVideoStream: [''],
      defaultStatusAfterLogin: [''],
      volume: [this.userData.volume],
      employeeType: [''],
      callTypes: this._formBuilder.array(this.userCalltypes),
      languages: this._formBuilder.array(this.languageSkills),
    });

    // Disable the fileds from editing
    this.userProfileForm.get('languages').disable();
    this.userProfileForm.controls.emailId.disable();
    this.userProfileForm.controls.country.disable();
    this.userProfileForm.controls.userRole.disable();
  }

  // Form submission
  submitUserProfileForm() {
    let userFullData = this._localDataService.getLoginData();
    userFullData.user.volume = this.userData.volume;
    this._localDataService.setLoginUserData(userFullData);
    let payload = this.payloadData();
    this._loginService.editUserPreferences(payload).subscribe({
      next: (result: any) => {
        if (result?.body?.status == true) {
          this._notificationService.successMessage(this._localizationService.instant('user_profile.successMsg'), 'Success')
        } else {
          this._notificationService.errorMessage(this._localizationService.instant('user_profile.exceptionMsg'), 'Error')
        }
      }
    });
    this.onDialogCancel();
  }

  // Payload for form submission
  payloadData() {
   let payload: any = {};
   Object.assign(payload, this.userData);
   payload.priority = 4;
   payload.usertype = "ccc";
   payload.isAvaya = false;
   payload.isTwilioLoaded = true,
   payload.allowedNotify = false
   return payload;
  }

  get callTypes() {
    return this.userProfileForm.get('callTypes') as FormArray;
  }

  get languages() {
    return this.userProfileForm.get('languages') as FormArray;
  }

  onDialogCancel(): void {
    this._dialogRef.close();
  }

  clearTime: any;
  // // adjustVolume() {
  // //   this.userData.volume = this.userProfileForm.value.volume;
  // //   let audio = <HTMLAudioElement>document.getElementById("ringtoneVolume");
  // //   audio.load();
  // //   // pause the already playing audio, to handle multiple requests
  // //   if (this.clearTime != null) {
  // //     clearTimeout(this.clearTime);
  // //     this.clearTime = null;
  // //   }
  // //   audio.volume = this.userProfileForm.value.volume;
  // //   audio.play();
  // //   this.clearTime = setTimeout(function () {
  // //     audio.pause();
  // //   }, 3000)
  // // }
  formatLabel(value: number): string {
    return value * 100 + '%';
  }

}
